import React from "react";
import { StyledModal } from "./ModalTextSwitch.styled";
import { TitlesTyp } from "../../Typography/Typography";
import { FontWeightEnum, IconSizeEnum } from "../../../types/AppTypes";
import { IconManager } from "../IconManager/IconManager";
import { ReactComponent as CloseIcon } from "../../../icons/closeCircle.svg";
import ReactDOM from "react-dom";
import { OptionItem, TextSwitch } from "../../TextSwitch/TextSwitch";

type ModalProps<T> = {
  label: string;
  children: React.ReactNode;
  isOpen: boolean;
  closeModal?: () => void;
  rightButton?: React.ReactNode;
  leftButton?: React.ReactNode;
  message?: React.ReactNode;
  fullSize?: boolean;
  fullScreen?: boolean;
  dimHeader?: boolean;
  modalOptions: {
    value: T;
    label: string;
  }[];
  selectedModalOption: OptionItem<T>;
  setSelectedModalOption: (option: OptionItem<T>) => void;
};

export const ModalTextSwitch = <T,>({
  label,
  children,
  closeModal,
  isOpen,
  rightButton,
  leftButton,
  fullSize,
  fullScreen,
  dimHeader,
  message,
  modalOptions,
  selectedModalOption,
  setSelectedModalOption,
}: ModalProps<T>) => {
  if (!isOpen) {
    return null;
  }

  const showFooter = leftButton !== undefined || rightButton !== undefined;

  return ReactDOM.createPortal(
    <StyledModal
      $showFooter={showFooter}
      $fullSize={fullSize}
      $fullScreen={fullScreen}
      $dimHeader={dimHeader}
    >
      <div className="modal-box">
        <div className="modal-header">
          <div className="modal-header-title-switch">
            <TitlesTyp variant="3" fontWeight={FontWeightEnum.SEMIBOLD}>
              {label}
            </TitlesTyp>
            <TextSwitch
              options={modalOptions}
              selectedOption={selectedModalOption}
              setSelectedOption={setSelectedModalOption}
            />
          </div>
          {closeModal && (
            <IconManager size={IconSizeEnum.SMALL} onClick={() => closeModal()}>
              <CloseIcon data-testid="close-button" />
            </IconManager>
          )}
        </div>
        <div className="modal-content">{children}</div>
        {showFooter && (
          <div className="modal-footer">
            <div className="modal-footer-left">{message}</div>
            <div className="modal-footer-right">
              {leftButton}
              {rightButton}
            </div>
          </div>
        )}
      </div>
    </StyledModal>,
    document.body,
  );
};
